export const GET_LOCATION_AUTOCOMPLETE_LIST = 'GET_LOCATION_AUTOCOMPLETE_LIST';
export const GET_LOCATION_AUTOCOMPLETE_LIST_SUCCESS = `${GET_LOCATION_AUTOCOMPLETE_LIST}/SUCCESS`;
export const GET_LOCATION_AUTOCOMPLETE_LIST_FAILURE = `${GET_LOCATION_AUTOCOMPLETE_LIST}/FAILURE`;

export const GET_BUILDING_SUMMARY = 'GET_BUILDING_SUMMARY';
export const GET_BUILDING_SUMMARY_SUCCESS = `${GET_BUILDING_SUMMARY}/SUCCESS`;
export const GET_BUILDING_SUMMARY_FAILURE = `${GET_BUILDING_SUMMARY}/FAILURE`;

export const GET_WATERSHED_ID_BY_LOCATION = 'GET_WATERSHED_ID_BY_LOCATION';
export const GET_WATERSHED_ID_BY_LOCATION_SUCCESS = `${GET_WATERSHED_ID_BY_LOCATION}/SUCCESS`;
export const GET_WATERSHED_ID_BY_LOCATION_FAILURE = `${GET_WATERSHED_ID_BY_LOCATION}/FAILURE`;

export const GET_WATERSHED_BY_LOCATION = 'GET_WATERSHED_BY_LOCATION';
export const GET_WATERSHED_BY_LOCATION_SUCCESS = `${GET_WATERSHED_BY_LOCATION}/SUCCESS`;
export const GET_WATERSHED_BY_LOCATION_FAILURE = `${GET_WATERSHED_BY_LOCATION}/FAILURE`;

export const GET_EXPERIMENT_BY_LOCATION = 'GET_EXPERIMENT_BY_LOCATION';
export const GET_EXPERIMENT_BY_LOCATION_SUCCESS = `${GET_EXPERIMENT_BY_LOCATION}/SUCCESS`;
export const GET_EXPERIMENT_BY_LOCATION_FAILURE = `${GET_EXPERIMENT_BY_LOCATION}/FAILURE`;

export const SAVE = 'SAVE';
export const SAVE_SUCCESS = `${SAVE}/SUCCESS`;
export const SAVE_FAILURE = `${SAVE}/FAILURE`;

export const RESET_BUILDING_SUMMARY = 'RESET_BUILDING_SUMMARY';

export const CREATE_BUILDINGS_QR_STICKERS_PDF = 'CREATE_BUILDINGS_QR_STICKERS_PDF';
export const CREATE_BUILDINGS_QR_STICKERS_PDF_SUCCESS = `${CREATE_BUILDINGS_QR_STICKERS_PDF}/SUCCESS`;
export const CREATE_BUILDINGS_QR_STICKERS_PDF_FAILURE = `${CREATE_BUILDINGS_QR_STICKERS_PDF}/FAILURE`;

export default {
  GET_LOCATION_AUTOCOMPLETE_LIST,
  GET_LOCATION_AUTOCOMPLETE_LIST_SUCCESS,
  GET_LOCATION_AUTOCOMPLETE_LIST_FAILURE,

  GET_BUILDING_SUMMARY,
  GET_BUILDING_SUMMARY_SUCCESS,
  GET_BUILDING_SUMMARY_FAILURE,

  GET_WATERSHED_ID_BY_LOCATION,
  GET_WATERSHED_ID_BY_LOCATION_SUCCESS,
  GET_WATERSHED_ID_BY_LOCATION_FAILURE,

  GET_WATERSHED_BY_LOCATION,
  GET_WATERSHED_BY_LOCATION_SUCCESS,
  GET_WATERSHED_BY_LOCATION_FAILURE,

  GET_EXPERIMENT_BY_LOCATION,
  GET_EXPERIMENT_BY_LOCATION_SUCCESS,
  GET_EXPERIMENT_BY_LOCATION_FAILURE,

  SAVE,
  SAVE_SUCCESS,
  SAVE_FAILURE,

  RESET_BUILDING_SUMMARY,

  CREATE_BUILDINGS_QR_STICKERS_PDF,
  CREATE_BUILDINGS_QR_STICKERS_PDF_SUCCESS,
  CREATE_BUILDINGS_QR_STICKERS_PDF_FAILURE,
};
